export enum SettingsHeaderTypes {
    MEMBERS = 'members',
    ACCOUNT = 'account',
    MESSAGES = 'messages',
    TOKEN = 'token',
    STAGES = 'stages',
}